import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
export function formatFileName(fileName) {
  var fileExtension = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase();
  var fileNameNoExtension = fileName.replace(".".concat(fileExtension), '');
  var formattedFileName = "".concat(formatFileNameNoExtension(fileNameNoExtension), ".").concat(fileExtension);
  return formattedFileName;
}
var formatFileNameNoExtension = function formatFileNameNoExtension(fileName) {
  if (!fileName || typeof fileName !== 'string') return fileName;
  if (fileName.length > 10) {
    return "".concat(fileName.substr(0, 10), "[...]");
  }
  return fileName;
};